// A tela de entrada.
//
// Ela não existia, e a ausência não era um detalhe de acabamento: quando o
// passo 1.6 fechou `/api`, a interface passou a levar 401 em toda requisição e
// **não tinha como autenticar** — o navegador não abre o diálogo de Basic para
// `fetch`. A tela ficava presa em "Credencial ausente", sem caminho para a
// frente.
//
// A senha vai uma vez, por `POST /api/sessao`, e o que fica no navegador é um
// cookie `HttpOnly` que o JavaScript não lê. Guardar a senha no `localStorage`
// e reenviá-la a cada requisição seria mais simples e é o que se vê por aí —
// mas essas rotas promovem versão e disparam carga em massa, e um XSS levaria
// a credencial inteira em vez de uma sessão de doze horas.

import { useState, type FormEvent, type ReactNode } from "react";
import simbolo from "../assets/specifor-symbol.png";
import wordmark from "../assets/specifor-wordmark.png";
import { entrar } from "../api.js";

export function Entrada({ aoEntrar }: { aoEntrar: (operador: string) => void }): ReactNode {
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [indo, setIndo] = useState(false);

  async function enviar(e: FormEvent): Promise<void> {
    e.preventDefault();
    setErro(null);
    setIndo(true);
    try {
      const r = await entrar(usuario, senha);
      aoEntrar(r.operador);
    } catch {
      // Uma mensagem só, para usuário errado e senha errada — o servidor já não
      // distingue os dois, e distingui-los aqui desfaria o cuidado de lá.
      setErro("Usuário ou senha não conferem.");
      setSenha("");
    } finally {
      setIndo(false);
    }
  }

  return (
    <div className="entrada">
      <form className="entrada-cartao" onSubmit={(e) => void enviar(e)}>
        <div className="marca marca-entrada">
          <img className="marca-simbolo" src={simbolo} alt="" />
          <img className="marca-wordmark" src={wordmark} alt="Specifor" />
        </div>
        <div className="linha-versao">
          ATLAS
          <hr />
          <b>back office</b>
        </div>

        <p className="entrada-nota">
          Cada pessoa entra com o próprio usuário. A promoção de versão é uma assinatura, e a
          auditoria registra quem assinou.
        </p>

        <div className="campo">
          <label htmlFor="usuario">Usuário</label>
          <input
            id="usuario"
            name="usuario"
            autoComplete="username"
            autoFocus
            required
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
          />
        </div>

        <div className="campo">
          <label htmlFor="senha">Senha</label>
          <input
            id="senha"
            name="senha"
            type="password"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </div>

        {erro ? (
          <p className="entrada-erro" role="alert">
            {erro}
          </p>
        ) : null}

        <button className="btn-primario" type="submit" disabled={indo}>
          {indo ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
